// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OEMSetting_wrapper__1cQVe","container":"OEMSetting_container__nOSnn","title":"OEMSetting_title__2pEbH"};